import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { DomController } from '@ionic/angular';

interface ThemeStyle {
  themeVariable: string,
  value: string
}

@Injectable({
  providedIn: 'root'
})

export class ThemeService {
  private Themes: ThemeStyle[] = []

  public ThemesList = [
    {
      id: 1,
      name: 'BlackAndWhite',
      value: [
        { themeVariable: '--app-content', value: '#fff' },
        /* These Below 6 Variables are only used for background Colors of ion-header ion-content etc */
        { themeVariable: '--app-primary', value: '#11497B' },
        { themeVariable: '--app-secondary', value: '#11497B' },
        { themeVariable: '--app-secondary-dark', value: '#1a1a1a' },
        { themeVariable: '--app-tertiary', value: '#F4F4F4' },
        { themeVariable: '--app-dark', value: '#000' },
        { themeVariable: '--app-light', value: '#545454' },

        { themeVariable: '--app-text-primary', value: '#000' },
        { themeVariable: '--app-text-secondary', value: '#fff' },
        { themeVariable: '--app-text-dark', value: '#000' },
        { themeVariable: '--app-text-light', value: '##BCBCBC' },
        { themeVariable: '--app-text-light1', value: '#bfc1cb' },

        { themeVariable: '--app-btn-primary', value: '#11497B' },
        { themeVariable: '--app-btn-secondary', value: '#fff' },
        { themeVariable: '--app-btn-tertiary', value: '#e7e5e5' },
        { themeVariable: '--app-btn-light', value: '#fff' },


        { themeVariable: '--app-bdr-primary', value: '#11497B' },
        { themeVariable: '--app-bdr-secondary', value: '#fff' },
        { themeVariable: '--app-bdr-tertiary', value: '#98989887' },
        { themeVariable: '--app-bdr-dark', value: '#11497B' },
        { themeVariable: '--app-bdr-light', value: '#BCBCBC' },

        { themeVariable: '--app-active', value: '#1a1a1a' },
        { themeVariable: '--app-active2', value: '#FFC72C' },
        { themeVariable: '--app-active3', value: '#f9b401' },

        { themeVariable: '--app-warning', value: '#f47920' },
        { themeVariable: '--app-info', value: '#151827' },
        { themeVariable: '--app-primary-light', value: '#638c1c' },
        { themeVariable: '--app-black', value: '#1a1a1a' },
        { themeVariable: '--app-black1', value: '#030405' },
        { themeVariable: '--app-dark2', value: '#000000aa' },
        { themeVariable: '--app-light1', value: '#bfc1cb' },
        { themeVariable: '--app-light1-opacity', value: '#bfc1cb7a' },

        { themeVariable: '--app-gradient-bg-modal', value: 'linear-gradient(180deg, #1b1b1b,#000)' },
        { themeVariable: '--app-gradient-v', value: 'linear-gradient(0deg, #FADB8D, #F2CF81, #CE9F50)' },
        { themeVariable: '--app-gradient-h', value: 'linear-gradient(90deg, #FADB8D, #F2CF81, #CE9F50)' },
        { themeVariable: '--app-bar', value: 'linear-gradient(0deg, #FADB8D, #F2CF81, #CE9F50)' },
        // { themeVariable: '--app-primary', value: 'linear-gradient(200deg, #4a2267, #3a1e50, #1d0f29)' },

        { themeVariable: '--app-dashboard', value: '#41205A' },
        { themeVariable: '--app-subtext', value: '#fff' },
        // { themeVariable: '--app-active', value: '#70379B' },
        { themeVariable: '--app-accordianHeader', value: 'transparent' },
        { themeVariable: '--app-card1', value: 'transparent' },
        { themeVariable: '--app-primary-default', value: '#41205A' },

      ],
      primary: '#11497B',
      secondary: '#fff'
    },
    {
      id: 2,
      name: 'Ogre',
      value: [
        { themeVariable: '--app-content', value: '#fff' },

        /* These Below 6 Variables are only used for background Colors of ion-header ion-content etc */
        { themeVariable: '--app-primary', value: '#CB2026' },
        { themeVariable: '--app-secondary', value: '#DC0019' },
        { themeVariable: '--app-secondary-dark', value: '#C60006' },
        { themeVariable: '--app-tertiary', value: '#F4F4F4' },
        { themeVariable: '--app-dark', value: '#000' },
        { themeVariable: '--app-light', value: '#fff' },

        { themeVariable: '--app-text-primary', value: '#B20216' },
        { themeVariable: '--app-text-secondary', value: '#DC0019' },
        { themeVariable: '--app-text-dark', value: '#000' },
        { themeVariable: '--app-text-light', value: '#BCBCBC' },
        { themeVariable: '--app-text-light1', value: '#bfc1cb' },

        { themeVariable: '--app-btn-primary', value: '#B20216' },
        { themeVariable: '--app-btn-secondary', value: '#DC0019' },
        { themeVariable: '--app-btn-tertiary', value: '#e7e5e5' },
        { themeVariable: '--app-btn-light', value: '#fff' },

        { themeVariable: '--app-bdr-primary', value: '#E3E5E5' },
        { themeVariable: '--app-bdr-secondary', value: '#B20216' },
        { themeVariable: '--app-bdr-tertiary', value: '#BCBCBC' },
        { themeVariable: '--app-bdr-dark', value: '#000' },
        { themeVariable: '--app-bdr-light', value: '#fff' },

        { themeVariable: '--app-active', value: '#A10018' },
        { themeVariable: '--app-active2', value: '#FFC72C' },
        { themeVariable: '--app-active3', value: '#f9b401' },

        { themeVariable: '--app-warning', value: '#f47920' },
        { themeVariable: '--app-info', value: '#151827' },
        { themeVariable: '--app-primary-light', value: '#638c1c' },
        { themeVariable: '--app-black', value: '#1a1a1a' },
        { themeVariable: '--app-black1', value: '#030405' },
        { themeVariable: '--app-dark2', value: '#000000aa' },
        { themeVariable: '--app-light1', value: '#bfc1cb' },
        { themeVariable: '--app-light1-opacity', value: '#bfc1cb7a' },

        { themeVariable: '--app-gradient-bg-modal', value: 'linear-gradient(180deg, #E31836, #43030D)' },
        { themeVariable: '--app-gradient-v', value: 'linear-gradient(0deg, #FADB8D, #F2CF81, #CE9F50)' },
        { themeVariable: '--app-gradient-h', value: 'linear-gradient(90deg, #FADB8D, #F2CF81, #CE9F50)' },
        { themeVariable: '--app-bar', value: 'linear-gradient(0deg, #FADB8D, #F2CF81, #CE9F50)' },
        // { themeVariable: '--app-primary', value: 'linear-gradient(200deg, #4a2267, #3a1e50, #1d0f29)' },

        { themeVariable: '--app-dashboard', value: '#41205A' },
        { themeVariable: '--app-subtext', value: '#fff' },
        // { themeVariable: '--app-active', value: '#70379B' },
        { themeVariable: '--app-accordianHeader', value: 'transparent' },
        { themeVariable: '--app-card1', value: 'transparent' },
        { themeVariable: '--app-primary-default', value: '#41205A' },
      ],
      primary: '#fff',
      secondary: '#000'
    },
    {
      id: 3,
      name: 'Blue',
      value: [
        { themeVariable: '--app-content', value: '#fff' },

        /* These Below 6 Variables are only used for background Colors of ion-header ion-content etc */
        { themeVariable: '--app-primary', value: '#254494' },
        { themeVariable: '--app-secondary', value: '#1C3985' },
        { themeVariable: '--app-secondary-dark', value: '#051641' },
        { themeVariable: '--app-tertiary', value: '#F4F4F4' },
        { themeVariable: '--app-dark', value: '#000' },
        { themeVariable: '--app-light', value: '#fff' },

        { themeVariable: '--app-text-primary', value: '#254494' },
        { themeVariable: '--app-text-secondary', value: '#6B6B6B' },
        { themeVariable: '--app-text-dark', value: '#BCBCBC' },
        // { themeVariable: '--app-text-light', value: '#fff' },
        { themeVariable: '--app-text-light1', value: '#bfc1cb' },

        { themeVariable: '--app-btn-primary', value: '#254494' },
        { themeVariable: '--app-btn-secondary', value: '#1C3985' },
        { themeVariable: '--app-btn-tertiary', value: '#e7e5e5' },
        { themeVariable: '--app-btn-light', value: '#fff' },

        { themeVariable: '--app-bdr-primary', value: '#E3E5E5' },
        { themeVariable: '--app-bdr-secondary', value: '#254494' },
        { themeVariable: '--app-bdr-tertiary', value: '#BCBCBC' },
        { themeVariable: '--app-bdr-dark', value: '#000' },
        { themeVariable: '--app-bdr-light', value: '#fff' },

        { themeVariable: '--app-active', value: '#3565C5' },
        { themeVariable: '--app-active2', value: '#FFC72C' },
        { themeVariable: '--app-active3', value: '#f9b401' },

        { themeVariable: '--app-warning', value: '#f47920' },
        { themeVariable: '--app-info', value: '#151827' },
        { themeVariable: '--app-primary-light', value: '#638c1c' },
        { themeVariable: '--app-black', value: '#1a1a1a' },
        { themeVariable: '--app-black1', value: '#030405' },
        { themeVariable: '--app-dark2', value: '#000000aa' },
        { themeVariable: '--app-light1', value: '#bfc1cb' },
        { themeVariable: '--app-light1-opacity', value: '#bfc1cb7a' },

        { themeVariable: '--app-gradient-bg-modal', value: 'linear-gradient(180deg, #254494, #051641)' },
        { themeVariable: '--app-gradient-v', value: 'linear-gradient(0deg, #FADB8D, #F2CF81, #CE9F50)' },
        { themeVariable: '--app-gradient-h', value: 'linear-gradient(90deg, #FADB8D, #F2CF81, #CE9F50)' },
        { themeVariable: '--app-bar', value: 'linear-gradient(0deg, #FADB8D, #F2CF81, #CE9F50)' },
        // { themeVariable: '--app-primary', value: 'linear-gradient(200deg, #4a2267, #3a1e50, #1d0f29)' },

        { themeVariable: '--app-dashboard', value: '#41205A' },
        { themeVariable: '--app-subtext', value: '#fff' },
        // { themeVariable: '--app-active', value: '#70379B' },
        { themeVariable: '--app-accordianHeader', value: 'transparent' },
        { themeVariable: '--app-card1', value: 'transparent' },
        { themeVariable: '--app-primary-default', value: '#41205A' },
      ],
      primary: '#fff',
      secondary: '#000'
    },
    {
      id: 4,
      name: 'Green',
      value: [
        { themeVariable: '--app-content', value: '#fff' },

        /* These Below 6 Variables are only used for background Colors of ion-header ion-content etc */
        { themeVariable: '--app-primary', value: '#00A752' },
        { themeVariable: '--app-secondary', value: '#008934' },
        { themeVariable: '--app-secondary-dark', value: '#00321E' },
        { themeVariable: '--app-tertiary', value: '#F4F4F4' },
        { themeVariable: '--app-dark', value: '#000' },
        { themeVariable: '--app-light', value: '#fff' },

        { themeVariable: '--app-text-primary', value: '#1B542A' },
        { themeVariable: '--app-text-secondary', value: '#1B542A' },
        { themeVariable: '--app-text-dark', value: '#000' },
        { themeVariable: '--app-text-light', value: '#ffffff' },
        { themeVariable: '--app-text-light1', value: '#bfc1cb' },
        { themeVariable: '--app-all-text', value: '#00000080' },


        { themeVariable: '--app-btn-primary', value: '#00A752' },
        { themeVariable: '--app-btn-secondary', value: '#008934' },
        { themeVariable: '--app-btn-tertiary', value: '#e7e5e5' },
        { themeVariable: '--app-btn-light', value: '#fff' },

        { themeVariable: '--app-bdr-primary', value: '#E3E5E5' },
        { themeVariable: '--app-bdr-secondary', value: '#00A752' },
        { themeVariable: '--app-bdr-tertiary', value: '#BCBCBC' },
        { themeVariable: '--app-bdr-dark', value: '#000' },
        { themeVariable: '--app-bdr-light', value: '#fff' },

        { themeVariable: '--app-active', value: '#006A34' },
        { themeVariable: '--app-active2', value: '#FFC72C' },
        { themeVariable: '--app-active3', value: '#f9b401' },

        { themeVariable: '--app-warning', value: '#f47920' },
        { themeVariable: '--app-info', value: '#151827' },
        { themeVariable: '--app-primary-light', value: '#638c1c' },
        { themeVariable: '--app-black', value: '#1a1a1a' },
        { themeVariable: '--app-black1', value: '#030405' },
        { themeVariable: '--app-dark2', value: '#000000aa' },
        { themeVariable: '--app-light1', value: '#bfc1cb' },
        { themeVariable: '--app-light1-opacity', value: '#bfc1cb7a' },

        { themeVariable: '--app-gradient-bg-modal', value: '#00A752' },
        { themeVariable: '--app-gradient-v', value: 'linear-gradient(0deg, #FADB8D, #F2CF81, #CE9F50)' },
        { themeVariable: '--app-gradient-h', value: 'linear-gradient(90deg, #FADB8D, #F2CF81, #CE9F50)' },
        { themeVariable: '--app-bar', value: 'linear-gradient(0deg, #FADB8D, #F2CF81, #CE9F50)' },
        // { themeVariable: '--app-primary', value: 'linear-gradient(200deg, #4a2267, #3a1e50, #1d0f29)' },

        { themeVariable: '--app-dashboard', value: '#41205A' },
        { themeVariable: '--app-subtext', value: '#fff' },
        // { themeVariable: '--app-active', value: '#70379B' },
        { themeVariable: '--app-accordianHeader', value: 'transparent' },
        { themeVariable: '--app-card1', value: 'transparent' },
        { themeVariable: '--app-primary-default', value: '#41205A' },
      ],
      primary: '#fff',
      secondary: '#000'
    },
  ]

  constructor(
    public domCtrl: DomController,
    @Inject(DOCUMENT) private document,
  ) {
    this.Themes = this.ThemesList[0].value
  }

  setTheme(theme?) {
    let defaultTheme
    if (theme) {

      defaultTheme = [...theme]
    } else {

      defaultTheme = [...this.Themes]
    }
    // theme ? defaultTheme = [...theme] : defaultTheme = [...this.Themes]
    this.domCtrl.write(() => {
      defaultTheme.forEach((style) => {
        document.documentElement.style.setProperty(style.themeVariable, style.value)
      })
    })
  }

}